import { render } from "./ScaleVM.vue?vue&type=template&id=45690cea&scoped=true"
import script from "./ScaleVM.vue?vue&type=script&lang=js"
export * from "./ScaleVM.vue?vue&type=script&lang=js"

import "./ScaleVM.vue?vue&type=style&index=0&id=45690cea&scoped=true&lang=scss"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45690cea"]])

export default __exports__